import { Link } from 'react-router-dom';

import { FooterSocialIcons } from '@/components/icons/social-icons';
import Logo from '@/components/ui/logo';
import { ROUTES } from '@/constants/routes';

const footerLinks = [
  {
    title: 'Agent Suites',
    links: [
      { label: 'CollectWing', href: ROUTES.SUITE_DETAILS('collect-wing') },
      { label: 'SalesWing', href: ROUTES.SUITE_DETAILS('sales-wing') },
      { label: 'AdminWing', href: ROUTES.SUITE_DETAILS('admin-wing') },
      { label: 'Underwriting', href: ROUTES.SUITE_DETAILS('under-wing') },
    ],
  },
  {
    title: 'Core Agents',
    links: [
      { label: 'Mariana', href: ROUTES.AGENTS_DETAILS('mariana') },
      { label: 'Leanne', href: ROUTES.AGENTS_DETAILS('leanne') },
      { label: 'Prescilla', href: ROUTES.AGENTS_DETAILS('prescilla') },
      { label: 'Preeya', href: ROUTES.AGENTS_DETAILS('preeya') },
      { label: 'Undreta', href: ROUTES.AGENTS_DETAILS('undreta') },
      { label: 'Scyra', href: ROUTES.AGENTS_DETAILS('scyra') },
      { label: 'All Agents', href: ROUTES.MARKETPLACE },
    ],
  },
  {
    title: 'Platform',
    links: [
      { label: 'Marketplace', href: ROUTES.MARKETPLACE },
      { label: 'Integrations', href: ROUTES.INTEGRATIONS },
      {
        label: 'Agent Orchestration',
        href: `${ROUTES.MARKETPLACE}?tab=agents`,
      },
      // { label: 'Enterprise Control', href: ROUTES.MARKETPLACE },
      // { label: 'Adaptive Intelligence', href: ROUTES.MARKETPLACE },
      // { label: 'Pricing', href: ROUTES.PRICING },
    ],
  },
  {
    title: 'Resources',
    links: [
      // { label: 'Blog', href: ROUTES.BLOG },
      // { label: 'Documentation', href: ROUTES.BLOG },
      // { label: 'Release Notes', href: ROUTES.BLOG },
      // { label: 'Case Studies', href: ROUTES.BLOG },
      { label: 'Help Center', href: ROUTES.CONTACT },
      { label: 'Contact', href: ROUTES.CONTACT },
    ],
  },
  {
    title: 'Company',
    links: [
      { label: 'About', href: ROUTES.OUR_STORY },
      { label: 'Careers', href: ROUTES.OUR_STORY },
      // { label: 'Partners', href: ROUTES.OUR_STORY },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-[#060706] pb-12 pt-24 text-white">
      <div className="app-container">
        <div className="mb-24 grid grid-cols-1 gap-12 lg:grid-cols-12">
          {/* Brand Column */}
          <div className="pr-8 lg:col-span-4">
            <Logo />
            <p className="my-6 max-w-[287px] text-[13px] leading-[20px] text-stroke-100">
              Autonomous AI agents and coordinated suites for enterprise
              operations, decisioning, and workflow execution.
            </p>
            <div className="mt-8 flex flex-col gap-4">
              <div className="flex h-10 w-full max-w-[340px] items-center overflow-hidden rounded-[10px] bg-[#131413]">
                <input
                  type="email"
                  placeholder="Your email"
                  className="w-full rounded-l-[10px] border border-[#8e96a6] bg-transparent px-4 py-2 text-sm placeholder:text-stroke-100 focus:outline-none lg:w-[280px]"
                />
                <button className="hover:bg-white/20 rounded-r-[10px] border border-[#acb2bd] bg-[#515251] px-5 py-2 text-sm font-medium text-white transition-colors">
                  Subscribe
                </button>
              </div>
              <p className="text-xs text-stroke-100">
                Get product updates and insights
              </p>
              <a
                href="https://app.vanta.com/agentous.ai/trust/8fgitsplyl4ogm9b8yekl"
                target="_blank"
                rel="noopener noreferrer"
                className="font-ibm-plex-sans text-sm font-semibold leading-[16.5px] text-stroke-100 transition-opacity duration-200 hover:underline hover:opacity-80"
              >
                SOC 2 Type II audit in progress
              </a>
            </div>
          </div>

          {/* Links Columns */}
          <div className="grid grid-cols-2 gap-8 md:grid-cols-3 lg:col-span-8 lg:grid-cols-5">
            {footerLinks.map(column => (
              <div key={column.title}>
                <h3 className="mb-6 text-xs font-semibold uppercase tracking-wider text-stroke-100">
                  {column.title}
                </h3>
                <ul className="space-y-5 text-sm text-white">
                  {column.links.map(link => (
                    <li key={link.label}>
                      <Link
                        to={link.href}
                        className="leading-[21px] transition-colors hover:text-white"
                      >
                        {link.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="flex flex-col items-end gap-6 border-t border-[#ffffff0d] pt-8 text-sm text-stroke-100">
          <div className="flex w-full flex-wrap items-center justify-end gap-6">
            <span>© 2026 Agentous, Inc. All rights reserved.</span>
            <div className="flex items-center gap-6">
              <Link
                to={ROUTES.PRIVACY}
                className="transition-colors hover:text-white"
              >
                Privacy
              </Link>
              <span className="text-stroke-100">•</span>
              <Link
                to={ROUTES.TERMS}
                className="transition-colors hover:text-white"
              >
                Terms
              </Link>
              <span className="hidden text-stroke-100">•</span>
              <Link
                to={ROUTES.TERMS}
                className="hidden transition-colors hover:text-white"
              >
                Security
              </Link>
              <span className="hidden text-stroke-100">•</span>
              <Link
                to={ROUTES.TERMS}
                className="hidden transition-colors hover:text-white"
              >
                Cookies
              </Link>
            </div>
          </div>

          <div className="flex w-full justify-end">
            <FooterSocialIcons />
          </div>
        </div>
      </div>
    </footer>
  );
}
